import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Typography } from '@material-ui/core/'
import ErrorOutline from '@material-ui/icons/ErrorOutline'
import useStyles from './ErrorMessage.style'

/** Used to show error messages */
const ErrorMessage = (props) => {
  const { message } = props
  const classes = useStyles()
  return (
    <Grid container className={classes.container} alignItems='center'>
      <ErrorOutline color='primary' className={classes.icon} />
      <Grid container item>
        <Typography>{message}</Typography>
      </Grid>
    </Grid>
  )
}

ErrorMessage.propTypes = {
  /** The message to display */
  message: PropTypes.string.isRequired,
}

export default ErrorMessage
